var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mTierBenefits"
  }, [_c('div', {
    staticClass: "mTierBenefits-main"
  }, [_c('div', {
    staticClass: "mTierBenefits__title"
  }, [_vm._v(_vm._s(`Lv.${_vm.levelInfo} Perks:`))]), _vm.myInfo ? _c('div', {
    staticClass: "mTierBenefits__label"
  }, [_vm.myInfo.rewards?.[_vm.rewardsName]?.upgradeRewards?.ticket ? _c('span', [_c('svg-icon', {
    attrs: {
      "name": "icon-tier"
    }
  }), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.fmt_pre(_vm.myInfo.rewards[_vm.rewardsName]?.upgradeRewards?.ticket)))]), _vm._v(" Airdrop Pass")], 1) : _vm._e(), _vm.myInfo.rewards?.[_vm.rewardsName]?.maxSpins ? _c('span', [_c('svg-icon', {
    attrs: {
      "name": "icon-tier"
    }
  }), _vm._v(" Max Spins: "), _c('em', [_vm._v(_vm._s(_vm.fmt_pre(_vm.myInfo.rewards?.[_vm.rewardsName]?.maxSpins)))])], 1) : _vm._e(), _vm.myInfo.rewards?.[_vm.rewardsName]?.invitation?.paymentBonusRate?.stars ? _c('span', [_c('svg-icon', {
    attrs: {
      "name": "icon-tier"
    }
  }), this.$route.path == '/center' || this.$route.path != '/center' && this.isCurrent ? [_vm._v(" I get "), _c('em', [_vm._v(_vm._s(_vm.fmt_pre((_vm.myInfo.rewards?.[_vm.rewardsName]?.invitation?.paymentBonusRate?.stars ?? 0) * 100)) + "%")]), _vm._v(" of the stars from friends. ")] : [_vm._v(" I’ll earn "), _c('em', [_vm._v(_vm._s(_vm.fmt_pre((_vm.myInfo.rewards?.[_vm.rewardsName]?.invitation?.paymentBonusRate?.stars ?? 0) * 100)) + "%")]), _vm._v(" stars from friends. ")]], 2) : _vm._e()]) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };